export const SESSION_STORAGE_KEYS = {
    BEARER: 'B',
    TEMPLATE_FOR_PURCHASE: 'TP',
    SHOULD_REDIRECT_TO_NEW_PROJECT: 'RP',
    SHOULD_RELOAD_STEP2_PAGE: 'R',
};
